import { useEffect, useState } from "react"
import { getService } from "hooks/useStartup"
import { FetchClient } from "@/core/client/fetch_client"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { StatusCode } from "@/core/generated/api/enums/status_code"
import { Banner } from "../models/banner"

export const useBanners = () => {
  const [data, setData] = useState<Banner | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [code, setCode] = useState<number>(StatusCode.Ok)
  const [message, setMessage] = useState<string>("")

  const getData = async () => {
    setLoading(true)
    let response: ResponseModel | null = null

    try {
      const client: FetchClient = getService(FetchClient)
      response = await client.getAsync<ResponseModel>(`/banners`)
      if (response !== null) {
        const model: Banner | null =
          ResponseSerializer.deserialize<Banner>(response)
        if (model !== null) {
          setData(model)
          setCode(response.code)
        } else {
          setCode(StatusCode.NoContent)
        }
      } else {
        setCode(StatusCode.BadRequest)
      }
    } catch (err) {
      console.error(err)
      setCode(StatusCode.BadRequest)
    } finally {
      setMessage(response?.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return { data, loading, code, message }
}
